module.exports = __webpack_public_path__ + "static/media/how-you-want-to-start.7b4f538c.png";